import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useStore } from "../../../stores/store";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useTranslation } from "react-i18next";
import { useSnackbar } from "notistack";
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
import { useSubmitData } from "../../../hooks/useSubmitData";
import { useSetMenu } from "../../../hooks/useSetMenu";
import FormLayout from '../../Generic/FormLayout';
import FormInput from '../../Generic/FormInput';
import useAuth from '../../../hooks/useAuth';

const Add = () => {
  const { mainStore } = useStore();
  const { t } = useTranslation();
  const { auth } = useAuth();
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const axiosPrivate = useAxiosPrivate();
  useSetMenu(mainStore.RoleMenuType, mainStore.RoleMenuNo);
  const onError = (errors, e) =>
    enqueueSnackbar(t("onErrorSubmit"), { variant: "error" });

  const schema = yup.object({
    name: yup
      .string()
      .required(t('requiredField'))
      .max(256, t('maxLength', { max: 256 })),

  });

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  const sendData = useSubmitData(axiosPrivate, "/Roles", "/Role/List");
  // const onSubmit = data => sendData(data);
  const onSubmit = data => {
    sendData(data);
  };
  const onCancel = () => navigate(-1);

  useEffect(() => {
    // eslint-disable-next-line
  }, [t]);


  //#endregion

  return (
    <FormLayout title={t("roleCreateTitle")} onSubmit={handleSubmit(onSubmit, onError)} onCancel={onCancel}>
      <FormInput label="roleName" name="name" register={register} errors={errors} />
    </FormLayout>
  );
};

export default Add;
